import React, {Suspense} from "react";
import {Switch} from "react-router-dom";
import {ContentRoute, LayoutSplashScreen} from "../../../_metronic/layout";
import {ProjectsPage as Projects} from './pages/ProjectsPage';

export default function ProjectsPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/projects" component={Projects}/>
      </Switch>
    </Suspense>
  );
}
